import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconTheme({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle stroke={fill} cx="6" cy="6" r="5.5"/>
            <path fill={fill} d="M4 6v5c-1.657 0-3-2.239-3-5s1.343-5 3-5v5z"/>
        </svg>
    );
}

export default IconTheme;
